import { LeafletMouseEvent } from 'leaflet';

/** leaflet.markercluster が propagatedFrom に載せるクラスター（型定義に無いので最小形で受ける） */
type ChildMarker = { options?: { eventHandlers?: Record<string, unknown> } };
type Cluster = { getAllChildMarkers?: () => ChildMarker[] };

/**
 * ハンドラに渡す文脈。集合状態のピンからの呼び出しかを伝える。
 *
 * 「集合状態」はクラスターだけではない。同一地点の未割当案件は 1 本のピンにまとめる
 * ため（logposeTech/log_web_issues#2430）、単独のピンでも複数案件がぶら下がりうる。
 * そのため `fromCluster` ではなく `grouped` という名前にしている。
 */
export type GroupedPinContext = { grouped: true };

/**
 * クラスターのイベントを配下マーカーの同名ハンドラへ流す。
 *
 * 旧地図（PlanningMapOrderMarkers.presenter.tsx:36-52）と同じ仕組み。
 * これが無いとクラスターを押しても中身が選ばれず、まとまっている案件を
 * 選ぶ手段が地図側に無くなる。
 *
 * ハンドラを持たないマーカーが混ざっても残りを止めない（1 つの欠落で
 * 以降が選ばれないと、選択件数が静かにずれる）。
 */
export function forwardClusterEvent(name: 'click' | 'contextmenu') {
  return (event: LeafletMouseEvent): void => {
    const cluster = (event as unknown as { propagatedFrom?: Cluster }).propagatedFrom;
    const markers = cluster?.getAllChildMarkers?.() ?? [];
    markers.forEach((marker) => {
      const handler = marker.options?.eventHandlers?.[name];
      // クラスター経由であることを伝える。集合状態のピンで詳細ポップアップを
      // 出すかどうかは呼び出し側が決める（最後の 1 件だけ出ると紛らわしい）
      if (typeof handler === 'function') (handler as (ctx: GroupedPinContext) => void)({ grouped: true });
    });
  };
}
